<template>
  <div class="main">
    <p v-if="items.length==0">利用できるクーポンがありません</p>
    <div v-if="items.length>0">
      <p>
        <select class="custom-select mr-sm-2" v-model="couponid" v-if="items.length>1">
          <option v-for="opt in items" :value="opt[0]" :key="opt[0]">{{ opt[1] }}</option>
        </select>
      </p>
      <h5>{{ title }}<br>
        <small class="text-muted">利用期間：{{datestart}} ～ {{dateend}}</small>
      </h5>
      <h6>
      <span class="btn btn-warning btn-block" v-on:click="writeoff()" >クーポンを使用する</span>
      </h6>
      <img v-if="imgurl" v-bind:src="imgurl" class="card-img-top" alt="...">
      <p class="text-justify" v-html="body"></p>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created () {
    this.$store.state.title = 'クーポン'
    this.$store.state.confirmdef = this.confirmdef
  },
  data() {
    return {
      items: [],
      title: '',
      datestart: '',
      dateend: '',
      imgurl: '',
      body: '',
      couponid: '',
      confirmdef: {
        title: 'クーポンをご利用',
        msg: 'ＯＫボタンを押すと使用済みとなります。<br>継続しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  watch: {
    couponid: function(newVal) {
      console.log(newVal)
      const that = this
      that.items.forEach(function(item, index) {
        if (that.couponid == item[0]) {
          that.couponid = item[0]
          that.title = item[1]
          that.datestart = item[3]
          that.dateend = item[4]
          that.body = item[2].replace(/\n/g, '<br>')
          that.createdate = item[6]
        }
      });
    }
  },
  mounted() {
    const that = this
    sx.showWaiting()

    var params = {
      corpid: 40,
      options: JSON.stringify({
        status: '1'
      }),
      token: localStorage.getItem('token')
    }
    var url = that.$store.state.baseurl + '/app/mshelper/fetchCoupondefList'
    sx.request(
      url,
      params,
      function(result) {
        if (result.status === 'ok') {
          that.items = result.data.rows
          var item = result.data.rows[0]
          that.couponid = item[0]
          that.title = item[1]
          that.datestart = item[3]
          that.dateend = item[4]
          that.body = item[2].replace(/\n/g, '<br>')
          that.createdate = item[6]
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
        }
        sx.hideWaiting()
      },
      function() {
        sx.login(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
              var item = result.data.rows[0]
              that.couponid = item[0]
              that.title = item[1]
              that.datestart = item[3]
              that.dateend = item[4]
              that.body = item[2].replace(/\n/g, '<br>')
              that.createdate = item[6]
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
          }
        )
        sx.hideWaiting()
      }
    )
  },
  methods: {
    writeoff() {
      const that = this
      $('#myModalConfirm').modal('show')
      $("#confirm").click(function() {
        $('#myModalConfirm').modal('hide')
        if (that.$router.currentRoute.name != "Coupon") {
          return
        }
        sx.showWaiting()
        var params = {
          corpid: '40',
          couponid: that.couponid,
          items: JSON.stringify({
            status: '9',
            datestart: '',
            dateend: '',
            datefinish: ''
          }),
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/mshelper/writeOffCoupon'
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              sx.hideWaiting()
              sx.toastSuccess('クーポン1枚を使用しました。')
            } else if (result.status === 'err') {
              sx.toastError('クーポン使用に失敗しました！')
            } else {
              sx.toastError(result.message)
            }
          },
          function(result) {
            sx.login(
              url,
              params,
              function(result) {
                if (result.status === 'ok') {
                  sx.hideWaiting()
                  sx.toastSuccess('クーポン1枚を使用しました。')
                } else if (result.status === 'err') {
                  sx.toastError('クーポン使用に失敗しました！')
                } else {
                  sx.toastError(result.message)
                }
              },
              function(result) {
                sx.hideWaiting()
                sx.toastError('クーポン使用に失敗しました！')
                console.log('recovery failed')
              }
            )
          }
        )
        sx.hideWaiting()
      })
    }
  }
}
</script>
<style scoped>
.main {
  padding: 12px;
  margin: 20px;
}
.nav {
  padding: 20px;
  font-size:10pt;
}
.nav .nav-item {
  color:#fb6e14;
}
.nav .nav-item-none {
  color:#d2d2d2;
}
.nav a {
  font-weight: bold;
  color: #fb6e14;
}

.nav a.router-link-exact-active {
  color: #fb6e14;
}
</style>
